/*
 * Copyright © 2020-2025 Ocean Galaxy Inc. All Rights Reserved.
 * @Description: 上传到文件夹弹窗埋点 Hook (workgroup_b7748_c7990_click)
 * @LastEditors: yingongjing
 * @LastEditTime: 2026-02-10
 */

import { useCallback } from 'react'
import { useAppSelector } from '../../../../app/hooks'
import sensors, { sensorsRole } from '../../../../utils/sensors'

type ActionType =
  | 'enterPage'
  | 'createFolder'
  | 'cancel'
  | 'confirmUpload'
  | 'clickUploadAndDelete'
  | 'confirmAgreement'
  | 'confirmUploadAndDelete'

interface TrackParams {
  actionType: ActionType
  number1?: number // 照片总数
  photoNum?: number // 仅 actionType = confirmUpload, confirmUploadAndDelete 时上报，上传照片数
}

/**
 * 上传到文件夹弹窗埋点 Hook
 * 事件名: workgroup_b7748_c7990_click, requirement_id: 917
 */
export const useUploadToFolderModalTrack = () => {
  const groupID = useAppSelector((state) => state.group.groupId)
  const myRole = useAppSelector((state) => state.group.myRole)
  const role = sensorsRole(myRole)

  const trackUploadModal = useCallback(
    (params: TrackParams) => {
      sensors.track('workgroup_b7748_c7990_click', {
        requirement_id: 917,
        track_sign: 'aworkgroup.b7748.c7990.click.workgroup_b7748_c7990_click',
        actionType: params.actionType,
        number1: params.number1,
        photoNum: params.photoNum,
        groupID: groupID || '',
        role
      })
    },
    [groupID, role]
  )

  return { trackUploadModal }
}
